module.exports = __webpack_public_path__ + "img/doctor-active.73b0c78f.svg";